import React, { Component } from 'react';
import { Form, Row, Col, Button, message, Spin, Switch } from 'antd';
import { generate } from 'generate-password';
import { hashHistory } from 'react-router';

import { secondaryApp, createContributor } from "../services/firebase/firebase";

import ImageUpload from '../components/Items/ImageUploader';
import Input from '../components/UI/Input/Input';

import { updateObject } from '../shared/utility';

import { database } from '../services/firebase/firebase';

const defaultPlaceholderImage = "https://firebasestorage.googleapis.com/v0/b/implant-compare.appspot.com/o/images%2Fplaceholder.png?alt=media&token=18740d81-a9cd-4c0c-b98e-8f93cb4fa52c";

export default class CreateContributor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controls: {
        email: {
          elementType: 'input',
          label: 'Create Contributor',
          icon: true,
          elementConfig: {
            type: 'email',
            placeholder: 'Contributor email',
            id: "email"
          },
          value: '',
          validation: {
            required: true,
            isEmail: true
          },
          valid: false,
          touched: false
        },
        name: {
          elementType: 'input',
          label: 'Display Name',
          elementConfig: {
            type: 'text',
            placeholder: 'Contributor name',
            id: "name",
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        },
        password: {
          elementType: 'input',
          label: 'Password',
          elementConfig: {
            type: 'password',
            placeholder: 'Contributor password'
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        },
        repassword: {
          elementType: 'input',
          label: 'Confirm Password',
          elementConfig: {
            type: 'password',
            placeholder: 'Confirm contributor password'
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        },
        biography: {
          elementType: 'textarea',
          label: 'Biography',
          elementConfig: {
            placeholder: 'Contributor biography',
            rows: 5
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        },
        channel: {
          elementType: 'select',
          label: "Assign Channel",
          elementConfig: {
            placeholder: 'Select a channel',
            required: "required"
          },
          options: props.data.channels || [],
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false
        }
      },
      thumbnailUrl: '',
      thumbnailName: '',
      isImageDataSent: true,
      contributorIsExist: false,
      sending: false
    };

    this.defaultState = {...this.state};
  }

  inputChangeHandler = (event, controlName) => {
    const updatedControls = updateObject(this.state.controls, {
      [controlName]: updateObject(this.state.controls[controlName], {
        value: event.target ? event.target.value : event,
        // valid: checkValidaty(event.target.value, this.state.controls[controlName.validation]),
        touched: true
      })
    });
    this.setState({controls: updatedControls});
  }

  resetStateValue = () => {
    this.setState(this.defaultState);
  }

  async submitContributorForm(e) {
    e.preventDefault();
    if (this.validateFields()) {

      this.setState({sending: true});
      this.sendContributorData()
        .then((data) => {
          if (data && data.result === 'success') {
            message.success('Contributor added');
            this.resetStateValue();
          }
        })
        .catch(error => {
          this.setState({sending: false});
          message.error(`Error ${error}`);
        })
    }
  }

  validateFields() {
    const { controls, contributorIsExist } = this.state;
    const name = controls.name.value;
    const email = controls.email.value;
    const channel = controls.channel.value;
    const password = controls.password.value;
    const repassword = controls.repassword.value;

    if (!channel) {
      message.warn('Channel is required');
      return false
    }

    if (!email || email.length === 0) {
      message.warn('Email is required');
      return false
    }

    if (email && contributorIsExist) {
      return true
    }

    if (!name || name.length === 0) {
      message.warn('Name is required');
      return false
    }

    if (!password) {
      message.warn('Password is required');
      return false
    }

    if (!repassword) {
      message.warn('Password confirmation is required');
      return false
    }

    if (password !== repassword) {
      message.warn('Password and password confirmation do not match');
      return false
    }

    return true
  }

  async sendContributorData() {
    const { controls, thumbnailUrl, thumbnailName, contributorIsExist } = this.state;
    const name = controls.name.value;
    const email = controls.email.value;
    const channel = controls.channel.value;
    const biography = controls.biography.value;
    const password = controls.password.value ?
      controls.password.value
      : generate({
          length: 10,
          numbers: true
        });

    const userData = {
      DisplayName: name,
      Email: email,
      PhotoUrl: thumbnailUrl || defaultPlaceholderImage,
      thumbnailName: thumbnailName || '',
      biography: biography || '',
      instagram: ''
    };

    if (contributorIsExist) {
      let result = await database.ref('users/').once('value');
      result = result.val();
      if (result) {
        const keys = Object.keys(result);
        const serchingUser = keys.map(key => {
          return {
            ...result[key],
            uid: key,
            email: result[key].Email
          }
        }).filter(user => {
          return user.Email === email;
        });

        if (serchingUser.length === 0) {
          this.setState({sending: false});
          return message.warn('Nothing found');
        }

        return createContributor(null, channel, serchingUser[0], null)
          .then((res) => {
            serchingUser[0].uid && hashHistory.push(`/profile/${serchingUser[0].uid}`);
            // return res && res.data
          })
          .catch(error => {message.error(`Error ${error}`)});
      }
    }

    return secondaryApp.auth().createUserWithEmailAndPassword(email, password)
      .then((firebaseUser) => {
        // secondaryApp.auth().signOut();
        if (firebaseUser) {
          return createContributor(userData, channel, firebaseUser.user, password)
            .then((res) => {
              firebaseUser.user.uid && hashHistory.push(`/profile/${firebaseUser.user.uid}`);
              // return res && res.data
            })
            .catch(error => {message.error(`Error ${error}`)})
        }

        return null
      });
  }

  handleUpdateImage(url, thumbnailName) {
    message.success('Image uploaded. Please, save form');
    this.setState({
      thumbnailUrl: url,
      thumbnailName: thumbnailName,
      isImageDataSent: false,
    });
  }

  onSwitchChange(checked) {
    const updatedControls = updateObject(this.state.controls, {
      name: updateObject(this.state.controls.name, {
        elementConfig: updateObject(this.state.controls.name.elementConfig, {
          disabled: checked
        })
      }),
      password: updateObject(this.state.controls.password, {
        elementConfig: updateObject(this.state.controls.password.elementConfig, {
          disabled: checked
        })
      }),
      repassword: updateObject(this.state.controls.repassword, {
        elementConfig: updateObject(this.state.controls.repassword.elementConfig, {
          disabled: checked
        })
      }),
      biography: updateObject(this.state.controls.biography, {
        elementConfig: updateObject(this.state.controls.biography.elementConfig, {
          disabled: checked
        })
      })
    });

    this.setState({ contributorIsExist: checked, controls: updatedControls});
  }

  render() {
    const { sending } = this.state;
    const { isAdmin } = this.props;

    const formElementsArray = [];
    for (let key in this.state.controls) {
      formElementsArray.push({
        id: key,
        config: this.state.controls[key]
      })
    }
    let form = formElementsArray.map(formElement => (
      <Input
        label={formElement.config.label}
        key={formElement.id}
        icon={formElement.config.icon}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        options={formElement.config.options}
        value={formElement.config.value}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        invalid={!formElement.config.valid}
        noShown={formElement.config.noShown}
        selectChange={(value, option) => this.inputChangeHandler({
          id: value,
          title: option.props.title
        }, formElement.id)}
        changed={(event) => this.inputChangeHandler(event, formElement.id)}
      />
    ));

    let preloader = '';
    if (sending) {
      preloader = (
        <div className="preloader-wr">
          <Spin className="preloader" />
        </div>
      );
    }

    return (
      <React.Fragment>
        <Form onSubmit={(e) => this.submitContributorForm(e)} className="edit-form">
          <Row type="flex">
            <Col
              xs={24}
              md={{ span: 11, push: 1, order: 2 }}
              className="center-column"
            >
              {!this.state.contributorIsExist && (
                <ImageUpload
                  className="avatar-uploader"
                  uploadText="Add Avatar"
                  uploadItemAction={(downloadURL, thumbnailName) => this.handleUpdateImage( downloadURL, thumbnailName)}
                  imageUrl={this.state.thumbnailUrl || ''}
                  newElement={false}
                  thumbnailName={this.state.thumbnailName || ''}
                  isImageDataSent={this.state.isImageDataSent}
                  onImageUpload={(url, thumbnailName) => this.handleUpdateImage(url, thumbnailName)}
                />
              )}
            </Col>
            <Col xs={24} md={12}>
              <div className="ant-row ant-form-item">
                <div className="ant-col ant-form-item-label">
                  <label className="label-question" title="Assign existing contributor to existing channel">Contributor already exists?</label>
                </div>
                <div className="ant-col ant-form-item-control-wrapper">
                  <div className="ant-form-item-control">
                    <Switch
                      checked={!!this.state.contributorIsExist}
                      onChange={(checked) => this.onSwitchChange(checked)}
                      checkedChildren="Yes"
                      unCheckedChildren="No"
                    />
                  </div>
                </div>
              </div>
              {form}
            </Col>
          </Row>
          <Row type="flex" className="edit-form-button-bar">
            <Col xs={24} md={12}>
              <Form.Item className="form-center-buttons">
                <Row>
                  <Col>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button"
                      disabled={!isAdmin}
                    >
                      Create Contributor
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        {preloader}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CreateContributor.js